import Vue from 'vue'///dist/vue.min.js'
import TheNavigation from './components/the-navigation.vue'
import TheProductFilter from './components/the-product-filter.vue'

Vue.config.productionTip = false


// tried to wrap whole body, didn't work, so introduced two mount points.

if(document.querySelector('#the-navigation')){
	new Vue({
		render(createElement){
			return createElement(TheNavigation)
		}
	}).$mount('#the-navigation')
}


if(document.querySelector('#the-product-filter')){
	new Vue({
		render(createElement){
			return createElement(TheProductFilter)
		}
	}).$mount('#the-product-filter')
}